export default "__VITE_ASSET__B6A3DGKm__"